<template>
    <component ref="element" :is="tag" :class="rootClasses">
        <slot name="header"></slot>
        <img class="image" v-if="src" :src="src" />
        <header v-if="showHeader" :class="{ 'has-actions': hasActions }">
            <h1>
                <slot name="title">{{ title }}</slot>
                <span class="subTitle" v-if="subTitle">{{ subTitle }}</span>
            </h1>
            <div class="actions" v-if="!src">
                <slot name="actions"></slot>
            </div>
        </header>
        <div>
            <slot name="top"></slot>
        </div>
        <div :class="contentClasses">
            <slot></slot>
        </div>
    </component>
</template>
<script>
import { ref, computed, inject, onMounted, onUnmounted } from "vue";
export default {
    emits: ["resize"],
    props: {
        title: {
            type: String,
            default: ""
        },
        subTitle: {
            type: String,
            default: ""
        },
        src: {
            type: String,
            default: ""
        },
        tag: {
            type: String,
            default: "article"
        },
        layout: {
            type: String,
            default: ""
        },
        metricSize: {
            type: String,
            default: "md" //sm, md, lg
        },
        gridMin: {
            type: String,
            default: "20em"
        },
        responsive: {
            type: Boolean,
            default: false
        }
    },
    setup(props, context) {
        const $store = inject("$store");
        const $hasSlotContent = inject("$hasSlotContent");

        const isGrid = computed(() => {
            return props.layout === "grid";
        });

        const isTable = computed(() => {
            return props.layout === "table";
        });

        const hasTitle = computed(() => {
            return props.title !== "";
        });

        const isMetric = computed(() => {
            return props.layout === "metric";
        });

        const isEditing = computed(() => {
            return $store.getters.isEditing;
        });

        const cssMetricSize = computed(() => {
            return "metric-size-" + props.metricSize;
        });

        const hasSlotTitle = computed(() => {
            return !!context.slots.title;
        });

        const hasActions = computed(() => {
            return $hasSlotContent(context.slots["actions"]);
            // if (context.slots.actions) {
            // 	const result = context.slots.actions();
            // 	console.log(result);
            // 	for (const obj of result) {
            // 		//console.log(obj);
            // 		if (obj.component) {
            // 			return true;
            // 		}
            // 	}
            // }
            // return false;
        });

        const showHeader = computed(() => {
            return hasActions.value || !!props.title || hasSlotTitle.value;
        });

        const rootClasses = computed(() => {
            return {
                "prime-card": true,
                "has-title": props.title,
                "has-actions": hasActions.value,
                "has-image": props.src,
                "has-table": isTable.value,
                "has-metric": isMetric.value,
                "is-editing": isEditing.value
            };
        });

        const contentClasses = computed(() => {
            return {
                "prime-card-content": true,
                "prime-card-grid": isGrid.value,
                "prime-card-table": isTable.value,
                "prime-card-has-title": hasTitle.value,
                "prime-card-metric": isMetric.value,
                headerless: !showHeader.value,
                ...BuildCSS()
            };
        });

        const element = ref(null);

        const cardWidth = ref(0);

        const OnResize = (entry) => {
            cardWidth.value = entry.contentBoxSize[0].inlineSize / 16;
            context.emit("resize", cardWidth.value);
        };

        const BuildCSS = () => {
            const css = {};
            if (isMetric.value) {
                css[cssMetricSize.value] = true;
            }
            return css;
        };

        return {
            isGrid,
            isTable,
            hasTitle,
            isMetric,
            cssMetricSize,
            hasSlotTitle,
            hasActions,
            showHeader,
            rootClasses,
            contentClasses,
            element,
            BuildCSS
        };
    }
};
</script>
<style lang="scss">
@use "sass:color";
@use "@/assets/css/globalVars.scss" as *;

.prime-card-content.prime-card-grid {
    box-shadow: inset 0 0 5em 6em white;
    background-color: #00000005;

    &>.prime-card>.prime-card-content {
        margin-bottom: $margin-element-medium;

        &>p {
            font-size: 1rem;
            font-weight: 600;
            color: $text-black;
        }
    }
}

.subTitle {
    color: $text-gray;
    font-size: 14px;
    white-space: nowrap;
}

.prime-card-metric {
    display: flex;
    flex-wrap: wrap;
    gap: $card-gap;

    &>article {}

    &.metric-size-sm {
        &>article {
            flex-basis: 300px;
        }
    }

    &.metric-size-md {
        &>article {
            flex-basis: 40%;
        }
    }

    &.metric-size-lg {
        &>article {
            flex-basis: 60%;
        }
    }
}

.prime-card-metric>.prime-card {
    color: $text-gray;
    border: $border-hr;
    padding: 0.3rem 1rem !important;

    header {
        margin: 0 !important;
    }

    h2 {
        font-size: 14px !important;
        font-weight: 300;
    }

    .prime-card-content {
        font-size: 16px;
        font-weight: 600;
        //margin-bottom: 0.3rem !important;
    }
}

.prime-card-content.prime-card-table {
    margin-bottom: 0 !important;

    & .table-wrapper {
        margin-left: -$card-padding-x;
        margin-right: -$card-padding-x;

        ///////////TABLE (ANY)////////////

        & table.table {
            & tr {
                position: relative;

                &:hover {
                    background-color: $boyden-blue-lighter;
                }

                &>td {

                    &>a,
                    &>.field>label>a,
                    &>div>a {
                        position: relative;
                        z-index: 2;
                    }

                    &>button {
                        position: relative;
                        z-index: 2;
                    }

                    &:first-child>.default-link {
                        position: absolute;
                        z-index: 1;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            & th {
                color: #555;
                background-color: $color-background-dark;

                &:first-child {
                    border-top-left-radius: 0;
                }

                &:last-child {
                    border-top-right-radius: 0;
                }
            }
        }

        ///////////TABLE (MOBILE)////////////

        &.is-mobile table.table {
            & tr {
                &>td:first-child {
                    &>a {
                        //right: 0;
                        //padding-top: 0.5rem;
                        //padding-right: $margin-element-small;
                        //color: #fff;
                    }
                }
            }
        }

        ///////////TABLE (NOT MOBILE)////////////

        &:not(.is-mobile) table.table {
            border: none;
            border-radius: $card-radius;

            &>thead {
                & th {
                    //border-radius: $card-radius $card-radius 0 0;
                    //color: #fff;
                    //background-color: $boyden-blue-light;
                    white-space: nowrap !important;
                }
            }
        }
    }
}
</style>
<style lang="scss" scoped>
@use "@/assets/css/globalVars.scss" as *;

.prime-card {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border: 1px solid $color-border-hr;
    border-radius: $card-radius;
    padding: 0;
    background-color: #fff;

    &>header,
    &>footer,
    &>.prime-card-content {
        margin-left: $card-padding-x;
        margin-right: $card-padding-x;
    }

    &>header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        overflow: hidden;

        & h1,
        & h2 {
            display: flex;
            align-items: baseline;
            flex-wrap: wrap;
            gap: $margin-element-small;

            line-height: 1.2;

            &>span {
                line-height: 0;
            }
        }

        &>.actions {
            display: flex;
            align-items: center;
            gap: $margin-element-small;
        }
    }

    &>footer {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        gap: $margin-element-small;
        margin-bottom: $card-padding-y;
    }

    // & > .prime-card-content:not(.prime-card-table) {
    // 	margin-bottom: $card-padding-y;
    // }
    &>.prime-card-content {
        margin-bottom: $card-padding-y;

        &> :deep(h1),
        &> :deep(h2) {
            display: flex;
            align-items: baseline;
            flex-wrap: wrap;
            gap: $margin-element-small;

            line-height: 1.2;

            &>span {
                line-height: 0;
            }

            &:first-child {
                margin-top: -$margin-element-tiny;
            }
        }
    }

    &>.prime-card-content.headerless {
        margin-top: $margin-element-huge;

        &:deep(h2:first-child) {
            padding-bottom: 1rem;
        }
    }

    ///////////////////////CARD WITHOUT TITLE/////////////////////////

    &:not(.has-title) {
        &>.prime-card-content {
            //margin-top: $margin-element-large !important;
        }
    }

    ///////////////////////CARD IN A CARD/////////////////////////

    & .prime-card:not(.metric-row) {
        border: none;

        &>header {
            //height: 4rem !important;
            //border-bottom: none !important;

            &>h2 {
                display: flex;
                height: 100%;
                align-items: center;
                //color: red;
                //border-bottom: $border-hr;
            }
        }

        &>header,
        &>footer,
        &>.prime-card-content {
            margin-left: 0; //$card-padding-x;
            margin-right: 0; //$card-padding-x;
        }

        & .prime-card-content {
            margin-top: 0;
            margin-bottom: 0;
        }

        &.has-image {
            &>img {
                border-radius: $card-radius $card-radius 0 0;
                height: auto;
                max-width: unset;
            }
        }

        &.has-actions {
            &.has-image {
                &>header {
                    margin-top: $margin-element-large;
                    margin-bottom: $margin-element-small;

                    &>h2 {
                        font-size: 1.625rem;
                    }
                }
            }

            &:not(.has-image) {
                &>header {
                    margin-bottom: $margin-element-huge !important;
                    border-bottom: $border-hr;
                    min-height: 4.6rem;
                }
            }
        }

        &:not(.has-actions) {

            //padding: 0 $card-padding-y $card-padding-x $card-padding-y;
            &>header,
            &>footer,
            &>.prime-card-content {
                margin-left: 0; //$card-padding-x;
                margin-right: 0; //$card-padding-x;
            }

            &>header {
                margin-top: $margin-element-tiny !important;
                margin-bottom: $margin-element-tiny;
                height: $margin-body-medium !important;

                &>h2 {
                    font-size: 1.625rem;
                }
            }
        }
    }

    ///////////////////////CARD WITH GRID///////////////////////

    &>.prime-card-content.prime-card-grid {
        @include grid-minmax(20em, 1fr);
        grid-column-gap: $margin-element-large;
        grid-row-gap: $margin-element-medium;
        margin-bottom: $margin-element-medium !important;
        //box-shadow: inset 0 0 8em 8em white;
        background-color: #fff;

        &>.prime-card {
            //This had to be moved to the non-scoped style tag to work.
            // & > .prime-card-content > p {
            // 	font-size: 1rem;
            // 	font-weight: 600;
            // 	color: $text-black !important;
            // }

            // justify-content: center;

            &>header {
                margin-top: $margin-element-large;
                margin-bottom: 0;
                height: unset;
                border-bottom: none;

                &>h2 {
                    font-size: 0.875rem;
                    font-weight: 600;
                    color: $text-gray;
                }
            }
        }
    }

    ///////////////////////CARD WITH IMAGE///////////////////////

    &.has-image {

        &>header,
        &>footer,
        &>.prime-card-content {
            margin-left: $card-padding-x;
            margin-right: $card-padding-x;
        }

        &>img {
            //margin: 0 #{-$card-padding-y} 0 #{-$card-padding-y};
            border-radius: $card-radius $card-radius 0 0;
            //width: calc(100% + #{$card-padding-y * 2});
            height: auto;
            max-width: unset;
        }
    }

    ///////////////////////CARD WITH TABLE///////////////////////

    // &.has-table {
    // 	& > header {
    // 		margin-top: 0;
    // 		margin-bottom: 0;
    // 		min-height: 4.6rem;
    // 		border-bottom-width: 0;
    // 	}
    // 	& tr,
    // 	& thead {
    // 		overflow-x: hidden;
    // 	}
    // }

    ///////////////////////CARD WITH ACTIONS///////////////////////
    ///

    &.has-actions {
        &>header {
            flex-wrap: wrap;

            &>.actions {
                margin-left: auto;
            }
        }

        &.has-table>header {
            margin-bottom: $margin-element-small;
        }
    }

    &.has-actions:not(.has-table),
    &.has-actions.is-editing {
        &.has-image {
            &>header {
                margin-top: $margin-element-large;
                margin-bottom: $margin-element-small;
            }
        }

        &:not(.has-image) {
            &>header {
                position: relative;
                margin-bottom: $margin-element-large;
                border-bottom: $border-hr;
                min-height: 4.6rem;
            }
        }
    }

    ///////////////////////CARD WITHOUT ACTIONS///////////////////////

    &:not(.has-actions):not(.has-table) {
        //padding: 0 $card-padding-y $card-padding-x $card-padding-y;

        &>header {
            margin-top: 0;
            margin-bottom: $margin-element-small;
        }

        &:not(.has-image):not(.has-table) {
            &>header {
                position: relative;
                margin-bottom: $margin-element-large;
                border-bottom: $border-hr;
                min-height: 4.6rem;
            }
        }
    }
}</style>
